import { Component, Input, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CustomIcon, IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { CmsTaxonomyGeneral } from '@fcom/core-api';

import { MenuItemWithChildren, MenuJson } from '../../interfaces/menu.interface';
import { ElementTypes } from '../../interfaces';
import { NavigationMenuService } from '../../services';

@Component({
  selector: 'fin-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent {
  navigationMenuService = inject(NavigationMenuService);

  @Input()
  content$: Observable<MenuJson>;

  readonly isVisible$: Observable<boolean>;
  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  readonly CustomIcon = CustomIcon;
  readonly IconLibrary = IconLibrary;

  readonly menuItems$: Observable<MenuItemWithChildren[]>;
  public readonly ElementTypes = ElementTypes;

  constructor() {
    this.menuItems$ = this.navigationMenuService.menuItems$.pipe(map((data) => data.bottom));
    this.isVisible$ = this.navigationMenuService.isFooterVisible$;
  }
}
